// External libraries
import React from 'react';
import styled from 'styled-components';

// Icon code
import { Icon } from './_base';

const TwitterSVG = styled(Icon).attrs({ viewBox: '0 0 50 40' })`
    width: 1.25em;
`;

function TwitterIcon({ color = 'currentColor', ...props }) {
    return (
        <TwitterSVG data-test="icon-twitter" {...props}>
            <path
                d="M49.6,4.7c-1.8,0.8-3.8,1.3-5.8,1.6c2.1-1.2,3.7-3.2,4.4-5.6c-2,1.2-4.1,2-6.4,2.4C40,1.2,37.4,0,34.5,0c-5.6,0-10.1,4.5-10.1,10.1c0,0.8,0.1,1.6,0.3,2.3C16.2,12,8.8,8,3.8,1.8C2.9,3.3,2.4,5.1,2.4,6.9c0,3.5,1.8,6.6,4.5,8.4c-1.7-0.1-3.2-0.5-4.6-1.3v0.1c0,4.9,3.5,9,8.1,9.9c-0.8,0.2-1.7,0.4-2.7,0.4c-0.7,0-1.3-0.1-1.9-0.2c1.3,4,5,6.9,9.4,7c-3.5,2.7-7.8,4.3-12.5,4.3c-0.8,0-1.6,0-2.4-0.1c4.5,2.9,9.8,4.5,15.5,4.5c18.6,0,28.7-15.4,28.7-28.7c0-0.4,0-0.9,0-1.3C46.5,8.5,48.3,6.8,49.6,4.7"
                fill={color}
            />
        </TwitterSVG>
    );
}

export { TwitterIcon as default, TwitterIcon };
